/**
 * @readonly
 * @enum {string}
 */
export const TpmsStatisticsAggregationLevel = Object.freeze({
    TIME: 'TIME',
    TIME_ABSOLUTE: 'TIME_ABSOLUTE',
    ENTITY: 'ENTITY',
    ENTITYGROUP: 'ENTITYGROUP',
    ENTITY_ABSOLUTE: 'ENTITY_ABSOLUTE'
})
